import type { MockServer } from '@@/api/mock-server/server'

export function routes(server: MockServer): void {
  server.get(
    '/pre-registration/:provet_token/contact-methods/:appointment_token/:origin_token/',
    () => {
      return {
        contacts: [
          {
            id: 1,
            type: 'phone',
            masked_value: '+47*****789',
          },
          {
            id: 2,
            type: 'email',
            masked_value: 'joh***ian@gmail.com',
          },
        ],
      }
    },
  )
}
